import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportsDistanceUnit',
})
export class ReportsDistanceUnitPipe implements PipeTransform {
  transform(value: number): string {
    return value === 0 ? 'Miles' : 'KMs';
  }
}
